import React from 'react';
import { ServiceCard } from '../service-card/service-card';
import { cn } from '@src/utils/ui';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setFavoriteWishlist, delFavoriteWishlist } from '@src/redux/wishlistActions';
import { ServicePropType } from '../service-card/prop-types/service';

const fullScreenClasses = [
    'tw-grid-cols-1',
    'md:tw-grid-cols-2',
    'lg:tw-grid-cols-3',
    'xl:tw-grid-cols-4',
    'tw-px-[16px]',
    'md:tw-px-[32px]',
    'lg:tw-px-[48px]',
    'xl:tw-px-[64px]',
    '2xl:tw-px-[160px]'
];

export const ServicesList = ({
    services,
    className = '',
    hasFullScreenWidth = false,
    userID = null,
    onFavorited = null
}) => {
    const dispatch = useDispatch();

    const handleClickFavorite = (params, callback = null) => {
        dispatch(setFavoriteWishlist(params, callback));
    };

    const handleClickUnfavorite = (params, callback = null) => {
        dispatch(
            delFavoriteWishlist(
                {
                    userID: userID,
                    wishlistId: params.wishlistId
                },
                callback
            )
        );
    };

    return (
        <div
            className={cn([
                'sc-list',
                'tw-grid',
                'tw-gap-[34px]',
                'tw-w-full',
                'tw-max-w-[1600px]',
                'tw-mx-auto',
                'tw-justify-items-center',
                hasFullScreenWidth && fullScreenClasses,
                className
            ])}
        >
            {services.map((service, i) => (
                <ServiceCard
                    key={`${service.id}${i}`}
                    service={service}
                    onFavorited={onFavorited}
                    onFavorite={handleClickFavorite}
                    onUnFavorite={handleClickUnfavorite}
                    userID={userID}
                />
            ))}
        </div>
    );
};

ServicesList.propTypes = {
    services: PropTypes.arrayOf(ServicePropType),
    className: PropTypes.string,
    hasFullScreenWidth: PropTypes.bool,
    onFavorited: PropTypes.func,
    userID: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])])
};
